import React, {ReactElement} from 'react';
import {cx} from '@emotion/css';

import NavigationLinksGroup from '@fo/designSystem/Navigation/NavigationLinksGroup/NavigationLinksGroup';
import CtaCard from '@fo/designSystem/CtaCard/CtaCard';

import {INavigationSection} from '../../types';

import styles from './NavigationSectionMobile.styles';

function NavigationSectionMobile({card, col1, col2, col3}: INavigationSection): ReactElement {
  return (
    <div className={cx(styles.componentWrapper)} data-testid="ui.navigation.section.mobile">
      <div className={cx(styles.columns)}>
        {col1.map((group) => (
          <NavigationLinksGroup key={group.label} label={group.label} links={group.links} />
        ))}
      </div>
      <div className={cx(styles.columns)}>
        {col2 &&
          col2.map((group) => <NavigationLinksGroup key={group.label} label={group.label} links={group.links} />)}
      </div>
      <div className={cx(styles.columns)}>
        {col3 &&
          col3.map((group) => <NavigationLinksGroup key={group.label} label={group.label} links={group.links} />)}
      </div>
      {card && (
        <div className={cx(styles.columns)}>
          <CtaCard
            title={card.title}
            description={card.description}
            image={card.image}
            slug={card.slug}
            buttonLabel={card.buttonLabel}
            classes={{
              dialogueContents: cx(styles.dialogueContentsOverride),
            }}
          />
        </div>
      )}
    </div>
  );
}

export default NavigationSectionMobile;
